import React, { useEffect, useState } from "react";
import TitleComp from "../components/Title/title";
import TableComp from "../components/table/tables";
import DrawerComp from "../components/Drower/Drawer";
import moment from "moment";
import axios from "axios";
import { useDrawer } from "../context/drawer";
import { Button, Rate, Popconfirm, message } from "antd";
import { FaEdit, FaTrashAlt } from "react-icons/fa";

export default function Reviews() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageComp, setPageComp] = useState(1);
  const [limitComp, setLimitComp] = useState(10);
  const [totalData, setTotalData] = useState(0);

  const { drawerData, setDrawerData } = useDrawer();

  const fetchData = async () => {
    try {
      setLoading(true);
      const resp = await axios.get("https://skdm.in/server/sdg/reviews.php");

      if (resp?.data?.data) {
        const data = resp.data.data.map((item) => ({
          ...item,
          created_at: moment(item.created_at).format("DD MMM YYYY"),
        }));
        setList(data);
        setTotalData(data.length);
      }
    } catch (err) {
      message.error("Failed to fetch reviews");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleAdd = () => {
    setDrawerData({
      isOpen: true,
      type: "reviewAdd",
      title: "Add Review",
      data: null,
      onSuccess: fetchData,
    });
  };

  const handleEdit = (record) => {
    setDrawerData({
      isOpen: true,
      type: "reviewEdit",
      title: "Edit Review",
      data: record,
      onSuccess: fetchData,
    });
  };

  const handleDelete = async (id) => {
    try {
      await axios.post("https://skdm.in/server/sdg/reviews.php", {
        action: "delete",
        id,
      });
      message.success("Review deleted");
      fetchData();
    } catch {
      message.error("Delete failed");
    }
  };

  const columns = [
    { title: "Name", dataIndex: "name" },
    {
      title: "Rating",
      dataIndex: "rating",
      render: (rating) => <Rate disabled value={rating} />,
    },
    { title: "Date", dataIndex: "created_at" },
    {
      title: "Image",
      dataIndex: "image",
      render: (img) =>
        img ? (
          <img src={img} alt="review" width={50} height={50} />
        ) : (
          "No Image"
        ),
    },
    {
      title: "Action",
      render: (_, record) => (
        <div className="buttonGroup">
          <Button onClick={() => handleEdit(record)}>
            <FaEdit />
          </Button>

          <Popconfirm
            title="Delete this review?"
            onConfirm={() => handleDelete(record.id)}
          >
            <Button danger>
              <FaTrashAlt />
            </Button>
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <>
      <TitleComp
        name="Reviews"
        totalData={totalData}
        isShowButton
        handleDrawerAdd={handleAdd}
      />

      <TableComp
        data={list}
        columns={columns}
        loading={loading}
        pageComp={pageComp}
        limitComp={limitComp}
        setPageComp={setPageComp}
        setLimitComp={setLimitComp}
        totalData={totalData}
      />

      <DrawerComp />
    </>
  );
}
